import { render } from "./OverflowTableText.vue?vue&type=template&id=62fafec7&scoped=true"
import script from "./OverflowTableText.vue?vue&type=script&lang=js"
export * from "./OverflowTableText.vue?vue&type=script&lang=js"

import "./OverflowTableText.vue?vue&type=style&index=0&id=62fafec7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62fafec7"]])

export default __exports__